import { Store, Actions } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { CameraService } from '../engine/camera.service';
import { EngineService } from '../engine/engine.service';
import { PaintService } from '../engine/paint.service';
import { defineProcedure } from './define-procedure';
import { getCameraProcedures, getCameraEvents } from './procedures/camera';
import { getSceneProcedures, getSceneEvents } from './procedures/scene';
import { defineEvent } from './define-event';
import { getHumanEvents, getHumanProcedures } from './procedures/human';
import { HumanInterface } from './models/human.interface';
import { WebGLInfoModel } from './models/webgl-info.model';
import { getTimelineEvents, getTimelineProcedures } from './procedures/timeline';
import { AnimationService } from '../engine/animation.service';
import { getInputEvents, getInputProcedures } from './procedures/input';
import { getUIEvents, getUIProcedures } from './procedures/ui';
import { ImageService } from '../shared/image.service';
import { getLabelsEvents, getLabelsProcedures } from './procedures/labels';
import { LabelsService } from '../story/labels.service';
import { BdGraphService } from 'src/lib/graph/graph.service';
import { HistoryService } from '../history/history.service';

declare const Human: HumanInterface;
declare const SceneJS: any;

@Injectable({
  providedIn: 'root'
})
export class WidgetAPIHandler {

  private webGLInfo: WebGLInfoModel;

  constructor(
    private store: Store,
    private actions: Actions,
    private cameraService: CameraService,
    private engineService: EngineService,
    private animationService: AnimationService,
    private imageService: ImageService,    
    private paintService: PaintService,
    private labelsService: LabelsService,
    private graphService: BdGraphService,
    private historyService: HistoryService
  ) {
    this.webGLInfo = SceneJS.WEBGL_INFO;
  }

  listen() {
    this.initProcedures();
    this.initEvents();
  }

  private initEvents() {

    getHumanEvents().forEach(event => {
      defineEvent(event.eventName, event.aliasEvents, event.mapFn);
    });

    getSceneEvents().forEach(event => {
      defineEvent(event.eventName, event.aliasEvents, event.mapFn);
    });

    getCameraEvents(this.cameraService).forEach(event => {
      defineEvent(event.eventName, event.aliasEvents, event.mapFn);
    });

    getTimelineEvents().forEach(event => {
      defineEvent(event.eventName, event.aliasEvents, event.mapFn);
    });

    getInputEvents().forEach(event => {
      defineEvent(event.eventName, event.aliasEvents, event.mapFn);
    });

    getUIEvents().forEach(event => {
      defineEvent(event.eventName, event.aliasEvents, event.mapFn);
    });

    getLabelsEvents(Human, this.store).forEach(event => {
      defineEvent(event.eventName, event.aliasEvents, event.mapFn);
    });
  }

  private initProcedures() {
    getHumanProcedures(Human, this.webGLInfo).forEach(proc => {
      defineProcedure(proc);
    });

    getSceneProcedures(
      this.store,
      this.engineService,
      this.paintService,
      this.cameraService,
      this.graphService,
      this.historyService
    ).forEach(proc => {
      defineProcedure(proc);
    });
    
    getCameraProcedures(this.store, this.cameraService).forEach(proc => {
      defineProcedure(proc);
    });

    getTimelineProcedures(this.store, this.actions, this.animationService).forEach(proc => {
      defineProcedure(proc);
    });

    getInputProcedures(this.store).forEach(proc => {
      defineProcedure(proc);
    });

    getUIProcedures(Human, this.store, this.actions, this.engineService, this.imageService).forEach(proc => {
      defineProcedure(proc);
    });

    getLabelsProcedures(Human, this.store, this.labelsService).forEach(proc => {
      defineProcedure(proc);
    });
  }
}
